import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ConfigContext } from "../context/GlobalContext";
import BusinessDataValidation from "../helper/BusinessDataValidation";
import EditBusinessData from "../data/Firebase/Business/EditBusinessDataInFirebase";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Languages } from "../Utils/Languages";

const BusinessView = () => {
  const { state, dispatch } = useContext(ConfigContext);
  const navigate = useNavigate();

  const business_data = state?.BUSINESSES?.find(
    (business) => business.companyId === state?.SELECTEDBUSINESS
  );

  const [businessData, setBusinessData] = useState({
    companyPhoto: null,
    companyPhotoURL: business_data?.companyPhoto || "",
    companyName: business_data?.companyName || "",
    gstNumber: business_data?.gstNumber || "",
    address: business_data?.address || "",
    companyId: business_data?.companyId || "",
    creationDate: business_data?.creationDate || "",
    isArchive: business_data?.isArchive || "",
    terms: business_data?.terms || "",
    updateDate: new Date().getTime(),
    id: business_data?.id,
    currency: business_data?.currency || "INR"
  });

  const onBack = () => {
    navigate(-1);
  };




  return (
    <div className="card shadow-lg p-4 w-80 mt-20 position-relative">
      <div className="card-header">

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
          {/* Left Side - Back/Close Button */}
          <div className="d-flex align-items-center gap-2">
            <button
              onClick={() => { navigate(-1) }}
            >
              <i class="fa fa-arrow-left" style={{ fontSize: 18 }}></i>
            </button>
            <p className='fw-semibold mb-0' style={{ fontSize: 20 }}>{Languages[state?.LANGUAGE]?.view_business}</p>
          </div>
        </div>

      </div>
      <div className="card-body">
        <div className="text-center border border-top-0 border-start-0 border-end-0">
          <img
            src={businessData.companyPhotoURL || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(businessData.companyName)}
            alt="Company Logo"
            className={`border ${localStorage.getItem("theme") == "dark" ? "br-secondary" : "bt-dark"} border-width-2-px w-160-px h-160-px rounded-circle object-fit-contain p-2`}
          />
          <h6 className="mb-0 mt-10 mb-3 fw-medium fs-5">{businessData.companyName}</h6>
        </div>
        <div className="mt-24">
          <h6 className="text-xl mb-16">{Languages[state?.LANGUAGE]?.business_info}</h6>
          <ul className="mt-1">
            <li className="d-flex gap-1 mb-12">
              <span className="w-20 text-md fw-medium text-primary-light">
                Country
              </span>
              <span className="w-70 text-secondary-light fw-regular">
                : {businessData.currency}
              </span>
            </li>
            <li className="d-flex gap-1 mb-12">
              <span className="w-20 text-md fw-medium text-primary-light">
                {state?.TAXTYPE} Number
              </span>
              <span className="w-70 text-secondary-light fw-regular">
                : {businessData.gstNumber}
              </span>
            </li>
            <li className="d-flex gap-1 mb-12">
              <span className="w-20 text-md fw-medium text-primary-light">
                {Languages[state?.LANGUAGE]?.address}
              </span>
              <span className="w-70 text-secondary-light fw-regular">
                : {businessData.address}
              </span>
            </li>
            <li className="d-flex gap-1 mb-12">
              <span className="w-20 text-md fw-medium text-primary-light">
                {Languages[state?.LANGUAGE]?.tc_account_details}
              </span>
              <span className="w-70 text-secondary-light fw-regular">
                : {businessData.terms}
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Back Button */}
      <div className="align-self-end m-3">
        <button
          type="reset"
          onClick={() => {
            navigate(-1);
          }}
          className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
        >
          {Languages[state?.LANGUAGE]?.back}
        </button>
      </div>
    </div>
  );
};

export default BusinessView;
